export enum PATHS {
    Splash = "/",
    Home = "/home",
    Login = "/login",
    ChooseProfile = "/choose-profile",
    MovilAuth = "/movil-auth/:id",
    Onboarding = "/onboarding/:id",
    Match = "/match",
    GiveUp = "/give-up",
    Favorites = "/favorites",
    Config = "/configuration",
    Messages = "/messages",
    PreLogin = "/pre-login",
    Register = "/register"
}
